module.exports = __webpack_public_path__ + "static/media/man-running-alone.b59c6e17.jpg";